<template>
    <div >
     
        <gofix-default-table :settings="tableConfig"
            :table-items="tableItems"
            :tbody-tr-class="rowClass"
            @email-assign="emailAssign"
            @mark-as-unread="markAsUnread"
            @link-case="linkCaseItem"
            @new-case="newCaseItem"
            @load-items="getTableData"
            @resend-email="resendEmail"
            @row-click="clickToRowItem"
            @period-filter="(tableRequest) => {
                this.modals.period.tableRequest = tableRequest;
                this.modals.period.start_date = null;
                this.modals.period.end_date = null;
                this.modals.period.open = false;
             }"
             @exportCustom="showModalExportEmail"
             ref="gofixTable">
            

             <template slot="gofix_table:case_id" slot-scope="row">
                         <router-link v-if="row.item.case != null" class-active="active" :to="`/case/${row.item.case_id}`"><span>{{row.item.case.case_number}}</span></router-link>
            </template>

            <template slot="gofix_table:status" slot-scope="row">
                {{ row.item.case != null  ? row.item.case.status : "" }}
            </template>

            <template slot="gofix_table:from" slot-scope="row">
                <span v-html="row.item.from_name_address"></span>
            </template>
   

             <template slot="gofix_table:person_in_charge_id" slot-scope="row">
                {{ row.item.person_in_charge != null  ? row.item.person_in_charge.name : "" }}
            </template>

            <template slot="gofix_table:next_action" slot-scope="row">
                        {{row.item.case !=null  ? row.item.case.next_action : ""}}
                        
            </template>

             <template slot="gofix_table:assigned_by" slot-scope="row">
                        {{row.item.assigned_by !=null  ? row.item.assigned_by.name : ""}}
                        
            </template>
  
            <template slot="gofix_table:user_id" slot-scope="row">
                    <!-- @click.stop="doThisImages(row.item.attachments)" -->
                     <div v-if="row.item.locked == true" class="attachmentsColumn" style="padding-left: 0;" >
                         <a class="control-item-link cursor-pointer" @click="Unlocked(row.item.id,row.item.user)">
                             <img src="img/off.png" alt="Unlock" width="20" height="20">
                         </a>
                     </div>
            </template>


             <template slot="gofix_table:locked" slot-scope="row">
                {{row.item.status != null  ?row.item.status:""}}
            </template>
            
            
            
           
            
            
           
        </gofix-default-table>


        <!--Modals-->
        <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Case List" hide-footer :centered="true" v-model="modals.assign.open" size="xli">
                <caseList v-bind:email_id="modals.assign.email_id" v-bind:email="modals.assign.email"></caseList>
                <b-button-group class="d-block text-right">
                    <gofix-button label="Close" @click="modals.searchemail.open=false" noBorder></gofix-button>
                </b-button-group>
        </b-modal>

        <b-modal :no-close-on-backdrop="false" id="modal-ViewEmail" scrollable :title="modals.viewemail.title" hide-footer :centered="true" v-model="modals.viewemail.open"  size='xl' static>
            <b-form class="formInvoice pb-11"  v-bind:class="{'run-loading small-loading':modals.viewemail.loading}">
                <b-row v-if="has_assign_email_permission == 'true'">
                     <b-col md="8">
                        <gofix-button class="mr-4" label="Assign" @click="assignEmail"  outline></gofix-button>
                        <gofix-button class="mr-4" label="Link Existing Case" @click="linkingCase"  outline></gofix-button>
                        <gofix-button class="mr-4" label="New Case" @click="newCase"  outline></gofix-button>
                     </b-col>
                     <b-col md="4">
                        <b-button-group class="d-block text-right">
                            <b-button @click="downloadEML" class="mr-3 clientPrintIcon" title="Download" v-b-tooltip.hover size="sm"><i class="icon-cloud-download icons"></i></b-button>
                            <b-button @click="printNative" class="mr-3 clientPrintIcon" title="Browser Print" v-b-tooltip.hover size="sm"><i class="icon-printer icons"></i></b-button>
                        </b-button-group>
                     </b-col>
                </b-row>
                <b-row v-if="has_assign_email_permission == 'false' || has_assign_email_permission == 'null' || !has_assign_email_permission">
                    <b-col md="8">
                        <gofix-button class="mr-4" label="Link Existing Case" @click="linkingCase"  outline></gofix-button>
                        <gofix-button class="mr-4" label="New Case" @click="newCase"  outline></gofix-button>
                    </b-col>
                     <b-col md="4">
                        <b-button-group class="d-block text-right">
                            <b-button @click="downloadEML" class="mr-3 clientPrintIcon" title="Download" v-b-tooltip.hover size="sm"><i class="icon-cloud-download icons"></i></b-button>
                            <!-- <b-button @click="print" class="mr-3 clientPrintIcon" title="Print" v-b-tooltip.hover size="sm"><i class="icon-printer icons"></i></b-button> -->
                            <b-button @click="printNative" class="mr-3 clientPrintIcon" title="Browser Print" v-b-tooltip.hover size="sm"><i class="icon-printer icons"></i></b-button>
                        </b-button-group>
                     </b-col>
                </b-row>
                <br>
                <b-row>
                    <b-col md="12">
                        <div id="emailHeaders">
                            <gofix-text-field label="" class="mb-12 width-full gofixInput gofixTextFieldViewEmail" oneline >
                                <div class="labelTitle">
                                    <span class="label" >Date</span>
                                </div>
                                <div class="textValue">
                                    <span v-html="modals.viewemail.data.date"></span>
                                </div>
                            </gofix-text-field>
                            <gofix-text-field label="" class="mb-12 width-full gofixInput gofixTextFieldViewEmail" oneline >
                                <div class="labelTitle">
                                    <span class="label" >From</span>
                                </div>
                                <div class="textValue">
                                    <span v-html="modals.viewemail.data.from_name_address"></span>
                                </div>
                            </gofix-text-field>
                            <gofix-text-field label="" class="mb-12 width-full gofixInput gofixTextFieldViewEmail" oneline >
                                <div class="labelTitle">
                                    <span class="label" >To</span>
                                </div>
                                <div class="textValue">
                                    <span v-html="modals.viewemail.data.to"></span>
                                </div>
                            </gofix-text-field>
                            <gofix-text-field label="" class="mb-12 width-full gofixInput gofixTextFieldViewEmail" oneline >
                                <div class="labelTitle">
                                    <span class="label" >CC</span>
                                </div>
                                <div class="textValue">
                                    <span v-html="modals.viewemail.data.cc"></span>
                                </div>
                            </gofix-text-field>
                            <gofix-text-field label="" class="mb-12 width-full gofixInput gofixTextFieldViewEmail" oneline >
                                <div class="labelTitle">
                                    <span class="label" >Subject</span>
                                </div>
                                <div class="textValue">
                                    <span>{{modals.viewemail.data.subject}}</span>
                                </div>
                            </gofix-text-field>
                        </div>
                        <!-- <gofix-form-input-texteditor  label="" content="" v-model="modals.viewemail.data.body" disabled="disabled"></gofix-form-input-texteditor>                         -->
                        <iframe id="iframeNew" ref="iframeNew" :src="modals.iframe.src" width="100%" height="100%" scrolling="auto" @load="iframeNewLoaded"> </iframe>
                        <iframe id="iframePrint" ref="iframePrint" width="100%" height="70%" scrolling="auto" style="display:none"> </iframe>

                        <b-form-group label="Attachments" class="photosThumb clear-both">
                            
                            <ul class="list-thumb" v-if="modals.viewemail.data.files !== null" style="margin-left:100px!important;" >                 
                                <li  v-for="(item,key) in modals.viewemail.data.files" v-bind:key="key" @click="previewFile(item)">  {{item.image_file_name}}  </li>
                            </ul>
                        </b-form-group>

                    </b-col>
                </b-row>
              
                
            </b-form>
            <b-button-group class="d-block text-right">
               
            </b-button-group>

          
        </b-modal>

        <b-modal :no-close-on-backdrop="false" id="modal-EmailAssign" tall :title="modals.emailassign.title" hide-footer :centered="true" v-model="modals.emailassign.open"  size='xl'>
            <b-form class="formInvoice pb-11">
                <b-row>
                    <b-col md="12">
                        <gofix-form-dropdown
                                    label=""
                                    :placeholder="'Select Email Status'"
                                    :clearable="true"
                                    :required="true"
                                    v-model="email_status"
                                    :options="modals.emailassign.data.emailStatus">
                        </gofix-form-dropdown>
                    </b-col>
                </b-row>
                <br>

                 <b-row>
                    <b-col md="12">
                        <!-- v-model="modal.data.data_type" -->
                        <gofix-form-dropdown
                                    label=""
                                    :placeholder="'Select Person In Charge'"
                                    :clearable="true"
                                    :required="true"
                                    vLabel="text"
                                    v-model="person_in_charge"
                                    :options="modals.emailassign.data.personInCharge">
                        </gofix-form-dropdown>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12">
                        <!-- v-model="modal.data.data_type" -->
                        <div class="btnGroupPlus">
                           <gofix-button class="mr-3" label="Cancel" @click="close" outline></gofix-button>
                           <gofix-button class="mr-3" label="Submit" @click="update" outline></gofix-button>

                        </div>

                        
                    </b-col>
                </b-row>
                
            </b-form>

        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Print" title="Print PDF" hide-footer :centered="true" v-model="modals.printPDF.open_process" hide-header-close>
            <b-progress :max="100" height="3rem" show-progress animated>
                <b-progress-bar :value="100">
                    <span class="font-size-16">{{modals.printPDF.process}}</span>
                </b-progress-bar>
            </b-progress>
        </b-modal>
        
        <b-modal :no-close-on-backdrop="true" id="modal-Assign" title="Select reported date (export)" hide-footer :centered="true" v-model="modals.export.open">
            <b-form>
                <b-row>
                    <b-col md="6">
                        <gofix-form-input-date
                            v-model="modals.export.data.start_date"
                            label="Start Date"
                            @change="updateDate"
                            >
                        </gofix-form-input-date>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input-date
                            v-model="modals.export.data.end_date"
                            label="End Date"
                            :min-date="modals.export.min_date"
                            :max-date="modals.export.max_date"
                            >
                        </gofix-form-input-date>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" :loading="modals.export.loading" @click="exportEmails" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Export Data" hide-footer :centered="true" v-model="modals.export.open_process" hide-header-close>
            <b-progress :max="100" height="3rem" show-progress animated>
                <b-progress-bar :value="100">
                    <span class="font-size-16">{{modals.export.process}}</span>
                </b-progress-bar>
            </b-progress>
          </b-modal>
          <b-modal :no-close-on-backdrop="true" id="modal-Export-NLT-Message" hide-footer hide-header :centered="true" v-model="modals.export.message.open">
            <div class="center">
                The report is being processed by system. <br/>You will receive a link to download the report via email once it is ready.<br/><br/>
            </div>
            <b-button-group class="d-block text-right">
                <gofix-button label="CLOSE"  @click="modals.export.message.open = false" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'; //Import vueX
    import { filters } from '@/_filterVar.js'; // Import source filter
    const caseList = () => import('../email-integration/case_list.vue');
    const attachment = () => import('../attachments/list');
    const ViewerImage = () => import('../plugins/ViewerImage.vue');
    import html2pdf from 'html2pdf.js';
    import moment from 'moment';


    export default {
        name: 'jobs',
        components: {
            caseList,
            attachment,
            ViewerImage,
            
        },
        props:["job_status"],
        data() {
            let filter = JSON.parse(JSON.stringify(filters['email_list']));
            let filter_status = true;
            
            let dataSelect = {
                job_status: {
                    value: [
                        {value:'inbox', text: 'inbox'},
                        {value:'outbox', text: 'outbox'},
                        // {value: 'all', text: 'all'},
                        {value: 'ask', text: 'ask'},
                        {value: 'cstl', text: 'cstl'},
                        {value: 'Completed', text: 'Completed'},
                        {value: 'Verified', text: 'Verified'},
                        {value: 'Cancelled', text: 'Cancelled'},
                        {value: 'Expired', text: 'Expired'},
                        {value: 'End', text: 'End'},
                        {value: 'Inactive', text: 'Inactive'},
                        {value: 'qp', text: 'qp'},
                    ],
                    value_field: 'value',
                    text_field: 'text'
                }
            }


            if(this.job_status == "inbox"){
                dataSelect = {
                    job_status: {
                        value: [{value: 'inbox', text: 'inbox'}],
                        value_field: 'value',
                        text_field: 'text'
                    }
                }
            }

             if(this.job_status == "outbox"){
                dataSelect = {
                    job_status: {
                        value: [{value: 'outbox', text: 'outbox'}],
                        value_field: 'value',
                        text_field: 'text'
                    }
                }
            }

            if(this.job_status == "qp"){
                dataSelect = {
                    job_status: {
                        value: [{value: 'qp', text: 'qp'}],
                        value_field: 'value',
                        text_field: 'text'
                    }
                }
            }

            if(this.job_status == "ask"){
                dataSelect = {
                    job_status: {
                        value: [{value: 'ask', text: 'ask'}],
                        value_field: 'value',
                        text_field: 'text'
                    }
                }
            }

            

            if(this.job_status == "cstl"){
                dataSelect = {
                    job_status: {
                        value: [{value: 'cstl', text: 'cstl'}],
                        value_field: 'value',
                        text_field: 'text'
                    }
                }
            }

            return {
                items:[],
                tableConfig:{
                    dataSelect: dataSelect,
                    name: 'email-integration-list',
                    controls:{
                        create: false,
                        delete:false,
                        periodFilter: false,
                        linkCase: true,
                        newCase:true,
                        markAsUnread:true,
                        assign: true,
                        resend: this.job_status == 'outbox' ? true : false,
                        tableExport: false,
                        tableExportCustom: true,
                        tableExportCustomName: 'Export Inbox Email'
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "id",
                    sortDirection: "desc",
                },
                tableItems:[],
                user:null,
                modals:{
                    assign:{
                        open:false,
                        loading: false,
                        filter: null,
                        loading_fm_staff: false,
                        email_id:null,
                        email:null
                    },
                    iframeEl: null,
                    iframeElPrint: null,
                    iframe:{
                        src:"",
                    },
                    viewemail:{
                        open:false,
                        loading:false,
                        data:{
                            id:null,
                            from:null,
                            to: null,
                            cc:null,
                            subject:null,
                            body:"<h1>Some initial content</h1>",
                            remark:null,
                            files: null,
                            date: null,
                            mail_box: null,
                            s3_eml_url: null,
                        },
                        title: 'View Email',
                        
                    },
                    emailassign:{
                        open:false,
                        loading:false,
                        title: 'Email Assignment',
                         data:{
                            emailStatus:[],
                            personInCharge:[]
                        },
                    },
                    printPDF : {
                        open: false,
                        loading: false,
                        process: 'Printing PDF',
                        open_process: false
                    },
                    export: {
                        open: false,
                        loading: false,
                        open_process: false,
                        process: null,
                        message: {
                            open: false
                        },
                        data: {
                            start_date: null,
                            end_date: null
                        },
                        min_date: null,
                        max_date: null,
                    }
                },
                email_status:null,
                person_in_charge:null,
                selected_email_id:null,
                has_assign_email_permission:false,
                diagramStatus: {
                        "Open": [
                            {
                                value: "nlt-reply-to-eu-fcr",
                                label: "Reply to EU (FCR)"
                            },
                            {
                                value: "nlt-reply-to-eu-first-nfcr",
                                label: "Reply to EU (First NFCR)"
                            },
                            {
                                value: "nlt-close-a-case",
                                label: "Close a Case"
                            }
                        ],
                        "Replied to EU (NFCR)": [
                            {
                                value: "nlt-escalate-to-stakeholder",
                                label: "Escalate to Stakeholder"
                            },
                            {
                                value: "nlt-close-a-case",
                                label: "Close a Case"
                            }
                        ],
                        "Escalated": [
                            {
                                value: "nlt-receive-st-response",
                                label: "Receive ST response"
                            },
                            {
                                value: "nlt-1st-reminder",
                                label: "Send 1st ST reminder"
                            }
                        ],
                        "1st ST Reminder": [
                            {
                                value: "nlt-receive-st-response",
                                label: "Receive ST response"
                            },
                            {
                                value: "nlt-2nd-reminder",
                                label: "Send 2nd ST reminder"
                            },
                            {
                                value: "nlt-reply-to-eu-interim",
                                label: "Reply to EU (Interim)"
                            },
                        ],
                        "2nd ST Reminder": [
                            {
                                value: "nlt-receive-st-response",
                                label: "Receive ST response"
                            },
                            {
                                value: "nlt-3rd-reminder",
                                label: "Send 3rd ST reminder"
                            },
                            {
                                value: "nlt-reply-to-eu-interim",
                                label: "Reply to EU (Interim)"
                            },
                        ],
                        "3rd ST Reminder": [
                            {
                                value: "nlt-receive-st-response",
                                label: "Receive ST response"
                            },
                            {
                                value: "nlt-4th-reminder",
                                label: "Send 4th ST reminder"
                            },
                            {
                                value: "nlt-reply-to-eu-interim",
                                label: "Reply to EU (Interim)"
                            },
                        ],
                        "4th ST Reminder": [
                            {
                                value: "nlt-receive-st-response",
                                label: "Receive ST response"
                            },
                            {
                                value: "nlt-reply-to-eu-interim",
                                label: "Reply to EU (Interim)"
                            },
                            {
                                value: "nlt-deadline-passed-timer",
                                label: "Deadline passed (Timer)"
                            },
                        ],
                        "ST Replied": [
                            {
                                value: "nlt-reply-to-eu-final-nfcr",
                                label: "Reply to EU (Final NFCR)"
                            }
                        ],
                        "ST No Response": [
                            {
                                value: "nlt-reply-to-eu-final-nfcr",
                                label: "Reply to EU (Final NFCR)"
                            }
                        ],
                        "Replied to EU (Final NFCR)": [
                            {
                                value: "nlt-close-a-case",
                                label: "Close a Case"
                            }
                        ],
                        "Replied to EU (FCR)": [
                            {
                                value: "nlt-close-a-case",
                                label: "Close a Case"
                            }
                        ],
                    }
            }
        },
        computed: {
            ...mapGetters({
                UserLogin: "AuthController/user",
                contractSelector: 'ContractController/ClientContractID',
          
            })
        },
        
        mounted() {
            this.iframeEl=this.$refs.iframeNew;
            this.modals.iframeElPrint=this.$refs.iframePrint;
            
        },
        created() {
           
        },
        methods: {
            /*Table emit ----------------------------------------------------------------------*/
            
            async getTableData(callback) {
                
                const { tableRequest ,actionStatus, resolve,reject } = await callback();
               
                let default_filters=localStorage.getItem(this.tableConfig.name);
                let user_id;
 
                if(Object.keys(this.UserLogin).length >0)
                {
                   
                    if(!default_filters)
                    {
                        //
                         await this.$store.dispatch("CaseSettingsController/getEachUserEmailDefaultFilters", {'email':this.UserLogin.email})
                                    .then(response => {

                                        if(response){
                                            user_id=response.id;
                                        }

                                }).catch(err => {
                                console.log(err);
                            }); 

                            await this.$store.dispatch("CaseSettingsController/getDetailEmailDefaultFilters", {'id':this.UserLogin.roles[0].id})
                            .then(response => {

                                let filters = {}; 

                                
                                // check if response is null
                                if(response.selected_email_status)
                                {   
                                    // check string includes ','
                                    if(response.selected_email_status.includes(","))
                                    {
                                        let selected_email_status_arr = response.selected_email_status.split(',');

                                            filters = { ...filters, "assign_status": {
                                            "function": "=",
                                            "value": selected_email_status_arr
                                            } };

                                    }else
                                    {
                                        filters = { ...filters, "assign_status": {
                                            "function": "=",
                                            "value": [response.selected_email_status]
                                        } };
                                    }
                                   
                                }

                                if(response.selected_case_status)
                                {   
                                    // check string includes ','
                                    if(response.selected_case_status.includes(","))
                                    {
                                        let selected_case_status_arr = response.selected_case_status.split(',');

                                            filters = { ...filters, "status": {
                                            "function": "=",
                                            "value": selected_case_status_arr
                                        } };

                                    }else
                                    {
                                        filters = { ...filters, "status": {
                                            "function": "=",
                                            "value": [response.selected_case_status]
                                        } };
                                    }
                                   
                                }

                                if(response.filter_status=="Logged in FM User")
                                {
                                   
                                    filters={...filters,"person_in_charge_id":
                                    // this.UserLogin
                                    {"function":"=","value":[user_id],"text":this.UserLogin.name}
                                    }
                                }
                                
                                
                             
                                localStorage.setItem(this.tableConfig.name, JSON.stringify(filters));

                                let email_filters = JSON.parse(localStorage.getItem(this.tableConfig.name));
                                if(Object.keys(email_filters).length) 
                                {
                                    for (const [key, val] of Object.entries(email_filters)) 
                                    {
                                        if(tableRequest.filter[key]) {
                                            tableRequest.filter[key].function = val.function;
                                            tableRequest.filter[key].value    = val.value;
                                        }
                                    }
                                    actionStatus.showFilter = true;
                                }

                                this.$refs.gofixTable.forceRerender();
                            })
                            .catch(err => {
                               
                            })

                    }

                  


                }
               

                
                
                tableRequest.inbox_name = this.job_status;
                
                await this.$store.dispatch("EmailIntegrationController/getListEmails", tableRequest)
                    .then(response => {
                        this.tableItems = response.data.data.items;

                        this.tableConfig.total = response.data.data.total;
                        resolve(response.data.data);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the email list", "danger");
                        reject();
                    })
            },
           
            /*End table emit ------------------------------------------------------------*/
            
            
            Unlocked(email_id,user)
            {
                let is_role_authorize=this.isRoleAuthorizedToUnlock();


                if(user.id !== this.UserLogin.id && !is_role_authorize)
                {
                    return this.$alertNotification("This email is locked as ["+user.name+"] is working on it", "danger");
                }else
                {
                    let params = Object.assign({
                        email_id: email_id,
                        locked:false
                    });


                    this.$store.dispatch("EmailIntegrationController/locked", params)
                        .then(response => {
                            
                            if(response.data.data == 1){
                                
                                this.$refs.gofixTable.reloadTableKeepFilter();
                                // +email_id
                                return this.$alertNotification("Successfully Unlocked ");
                            }
                        })
                        .catch(err => {
                            // this.modals.assign.loading_fm_staff = false;
                            return this.$alertNotification("Something went wrong in Email Locked", "danger");
                        })
                }
                
            },
            isRoleAuthorizedToUnlock(){
                let user_roles=JSON.parse( localStorage.getItem('user_roles') ).data;
                
                let bol=false;
                for (let i = 0; i < user_roles.length; i++) {
                    if(user_roles[i].roles['email management-unlock email'].unlock_email==1)
                    {
                        bol=true;
                        break;
                    }
                }
                
                return bol;
            },

            async previewFile(attachment) {
                if(attachment.image_content_type && 
                   (attachment.image_content_type.includes('image') ||
                    attachment.image_content_type.includes('pdf')
                )
                ){
                    const link = document.createElement('a');
                    var path = this.$router.resolve({name: 'FilePreview', params: {file_id: attachment.id}}).href;
                    link.href= path;
                    link.setAttribute('target', '_blank');
                    document.body.appendChild(link);
                    link.click();
                }
                else{
                    await this.downloadAttachment(attachment);
                }
            },
            async downloadAttachment(item){
                        let url = item.url.original;
                        let params = {};
                        params.url = url;
                        params.image_file_name = item.image_file_name;

                        await this.$store.dispatch("FileDownloadController/getFile", params)
                        .then(response => {
                        })
                        .catch(err => {
                            this.$alertNotification("Can not download file", "danger");
                            console.log(err);
                        });
                    
                    return this.$alertNotification("Download attachment successfully!");
                
            },
            
           
            clickToRowItem(item, event)
            {      
                this.modals.viewemail.loading = true; 
                this.modals.viewemail.data.id = item.id;
                this.modals.viewemail.data.date = item.date;
                this.modals.viewemail.open=true;
                this.modals.viewemail.data.from = item.from;
                this.modals.viewemail.data.to=item.to;
                this.modals.viewemail.data.cc=item.cc;
                this.modals.viewemail.data.subject=item.subject;
                this.modals.viewemail.data.from_name = item.from_name;
                this.modals.viewemail.data.from_name_address = item.from_name_address;
                this.modals.viewemail.data.mail_box = item.mail_box;
                this.modals.viewemail.data.s3_eml_url = item.s3_eml_url;

                let user_roles=JSON.parse( localStorage.getItem('user_roles') ).data;
                let bol=false;
                for (let i = 0; i < user_roles.length; i++) {
                    if(user_roles[i].roles['email management-assign email'].assign_email==1)
                    {
                        bol=true;
                        break;
                    }
                }

                this.has_assign_email_permission=bol.toString();                
                
                let params_read= Object.assign({
                    email_id: item.id,
                    is_read:true
                });



                let params = Object.assign({
                        email_id: item.id
                });


                this.$store.dispatch("EmailIntegrationController/UpdateEmailRead", params_read)
                .then(response => {

                    this.$refs.gofixTable.reloadTableKeepFilter();
                        
                })
                .catch(err => {
                    
                })
                
                
                

                this.$store.dispatch("EmailIntegrationController/EachEmail", params)
                .then(response => {

                    this.iframeEl.style.height = 350 +'px';
                    var doc=this.iframeEl.contentWindow.document;
                    doc.open();
                    doc.write(response.data.data.body!=null?response.data.data.body:"");
                    doc.close();
                    this.modals.viewemail.data.body = response.data.data.body;
                    this.modals.viewemail.loading = false; 
                        
                })
                .catch(err => {
                    this.modals.viewemail.loading = false; 
                })


                if(item.attachments.length>0)
                {
                    this.modals.viewemail.data.files=item.attachments;
                }
                
                
                
            },
            assignEmail(){
                this.selected_email_id=this.modals.viewemail.data.id;
                this.email_status=null;
                this.person_in_charge=null;
                this.modals.emailassign.open=true;

                 let params = Object.assign({
                    email_id: this.selected_email_id,
                    contract_id: this.contractSelector ? this.contractSelector.id: null,    
                });

                this.$store.dispatch("CaseSettingsController/getUniqueListCaseEmailStatus", params)
                .then(response => {
                    if(response){
                        if(response.selected.assign_status!='Unassigned'){
                            this.email_status=response.selected.assign_status;
                        }
                        this.modals.emailassign.data.emailStatus=response.list.filter(function(item) {
                            return item !== 'Unassigned'
                        });
                    }
                  
                })
                .catch(err => {
                });



                this.$store.dispatch("CaseSettingsController/getNltCsoUserEmailDefaultFilters",params)
                .then(response => {
                    if(response.selected[0].value !== null && response.selected[0].text !== null)
                    {
                        this.person_in_charge = response.selected[0];
                    }
                    this.modals.emailassign.data.personInCharge=response.list;
                })
                .catch(err => {
                });

            },
            async emailAssign(callback)
            {
                const { ids,filter, resolve,reject } =  await callback();
                    
                this.selected_email_id=ids;
                this.modals.emailassign.open=true;
                this.email_status=null;
                this.person_in_charge=null;

                let params = Object.assign({
                        email_id: ids,
                        contract_id: this.contractSelector ? this.contractSelector.id: null,
                });
                
                this.$store.dispatch("CaseSettingsController/getUniqueListCaseEmailStatus", params)
                .then(response => {
                    if(response)
                    {
                        if(response.selected.assign_status!='Unassigned'){
                            this.email_status=response.selected.assign_status;
                        }
                        this.modals.emailassign.data.emailStatus=response.list.filter(function(item) {
                            return item !== 'Unassigned'
                        });
                    } 
                  
                })
                .catch(err => {
                });



                this.$store.dispatch("CaseSettingsController/getNltCsoUserEmailDefaultFilters",params)
                .then(response => {
                    
                    if(response.selected[0].value !== null && response.selected[0].text !== null)
                    {
                        this.person_in_charge = response.selected[0];
                    }
                    this.modals.emailassign.data.personInCharge=response.list;
                })
                .catch(err => {
                });

                

            },
            close()
            {
                this.modals.emailassign.open=false;
            },
            update()
            {
                if(!this.email_status){
                    return this.$alertNotification('Email Status is required.', "danger");
                }
                if(this.email_status=='Assigned' && !this.person_in_charge){
                    return this.$alertNotification('Person In Charge is required if Assigned is selected.', "danger");
                }
                let params = Object.assign({
                        email_id: this.selected_email_id,
                        person_in_charge:this.person_in_charge,
                        email_status:this.email_status,
                        assigned_by_email:this.UserLogin.email
                    });

                this.$store.dispatch("EmailIntegrationController/UpdateEmail",params)
                .then(response => {
                    this.modals.emailassign.open=false;
                    this.modals.viewemail.open=false;

                    this.$refs.gofixTable.reloadTableKeepFilter();
                })
                .catch(err => {
                });

            },
            linkingCase(){
                this.selected_email_id=this.modals.viewemail.data.id;

                let SelectedItem = this.tableItems.find(element => this.selected_email_id == element.id);
                


                if(SelectedItem.locked !== null && SelectedItem.locked == true){
                    
                    
                    if(SelectedItem.user_id==this.UserLogin.id)
                    {   
                        this.modals.assign.email_id=SelectedItem.id;
                        this.modals.assign.email=SelectedItem;
                        this.modals.assign.open=true;
                        
                    }else{
                        return this.$alertNotification("Sorry, you don't have permission to link this email", "danger");
                    }
                }else{


                    let params = Object.assign({
                        email_id: SelectedItem.id,
                        locked:true
                    });

                    this.$store.dispatch("EmailIntegrationController/locked", params)
                        .then(response => {
                            if(response.data.data == 1){
                                this.modals.assign.email_id=SelectedItem.id;
                                this.modals.assign.email=SelectedItem;
                                this.modals.assign.open=true;
                                
                            }
                        })
                        .catch(err => {
                            this.modals.assign.loading_fm_staff = false
                        })

                }

            },
            async markAsUnread(callback)
            {
                let { selected,ids,filter, resolve,reject } =  await callback();
                
                let params_read= Object.assign({
                    email_id: ids,
                    is_read:false
                });
                this.$store.dispatch("EmailIntegrationController/UpdateEmailRead", params_read)
                .then(response => {
                    selected.single=null;

                    this.$refs.gofixTable.reloadTableKeepFilter();
                    
                        
                })
                .catch(err => {
                    this.modals.assign.loading_fm_staff = false
                })

            },
            async linkCaseItem(callback){
                const { ids,filter, resolve,reject } =  await callback();
                
                let SelectedItem = this.tableItems.find(element => ids == element.id);
                


                if(SelectedItem.locked !== null && SelectedItem.locked == true){
                    
                    
                    if(SelectedItem.user_id==this.UserLogin.id)
                    {   
                        this.modals.assign.email_id=SelectedItem.id;
                        this.modals.assign.email=SelectedItem;
                        this.modals.assign.open=true;
                        
                    }else{
                        return this.$alertNotification("Sorry, you don't have permission to link this email", "danger");
                    }
                }else{


                    let params = Object.assign({
                        email_id: SelectedItem.id,
                        locked:true
                    });

                    this.$store.dispatch("EmailIntegrationController/locked", params)
                        .then(response => {
                            if(response.data.data == 1){
                                this.modals.assign.email_id=SelectedItem.id;
                                this.modals.assign.email=SelectedItem;
                                this.modals.assign.open=true;
                                
                            }
                        })
                        .catch(err => {
                            this.modals.assign.loading_fm_staff = false
                        })

                }
                
                
                


            },
            newCase(){
                this.selected_email_id=this.modals.viewemail.data.id;
                let SelectedItem = this.tableItems.find(element => this.selected_email_id == element.id);
                if(SelectedItem.locked !== null && SelectedItem.locked == true){

                    if(SelectedItem.user_id==this.UserLogin.id)
                    {   
                        this.$router.push(`/case/0/${this.selected_email_id}`);
                    }else{
                        return this.$alertNotification("Sorry, you don't have permission to link this email", "danger");
                    }
                    
                }else
                {
                    let params = Object.assign({
                        email_id: SelectedItem.id,
                        locked:true
                    });

                    this.$store.dispatch("EmailIntegrationController/locked", params)
                        .then(response => {
                            if(response.data.data == 1){
                                this.$router.push(`/case/0/${this.selected_email_id}`);
                            }
                        })
                        .catch(err => {
                        return this.$alertNotification("Sorry, you don't have permission to link this email", "danger");

                        })

                    
                }
            },
            async resendEmail(callback)
            {
                const { ids,filter, resolve,reject } =  await callback();
                let SelectedItem = this.tableItems.find(element => ids == element.id);

                if(SelectedItem.status !== null && (SelectedItem.status == 'failed' || SelectedItem.status == 'pending')){
                    

                      let params = Object.assign({
                        email_ids: SelectedItem.id
                    });

                    this.$store.dispatch("EmailIntegrationController/resendEmail", params)
                        .then(response => {
                            return this.$alertNotification("This email has been resent");
                        })
                        .catch(err => {
                            return this.$alertNotification("Error has occured", "danger");
                        })

                    
                }else 
                {
                    return this.$alertNotification("Sorry, this email has already sent", "danger");

                }
            },
            async newCaseItem(callback)
            {
                const { ids,filter, resolve,reject } =  await callback();
                let SelectedItem = this.tableItems.find(element => ids == element.id);

                if(SelectedItem.locked !== null && SelectedItem.locked == true){

                    if(SelectedItem.user_id==this.UserLogin.id)
                    {  
                        this.$router.push(`/case/0/${ids}`);
                    }else{
                        return this.$alertNotification("Sorry, you don't have permission to link this email", "danger");
                    }
                    
                }else
                {
                    let params = Object.assign({
                        email_id: SelectedItem.id,
                        locked:true
                    });

                    this.$store.dispatch("EmailIntegrationController/locked", params)
                        .then(response => {
                            if(response.data.data == 1){
                                this.$router.push(`/case/0/${ids}`);
                            }
                        })
                        .catch(err => {
                        return this.$alertNotification("Sorry, you don't have permission to link this email", "danger");

                        })

                    
                }


            },
            rowClass(item,type)
            {

                if(item)
                {
                    if(!item.is_read)
                    {
                        return 'row-case-new';
                    }else
                    {
                        return null;
                    }
                }
               
            },
            iframeNewLoaded(){
                if(this.iframeEl && this.iframeEl.contentWindow){
                    var iframe=this.iframeEl;
                    var modalBody = this.$el.querySelectorAll(`#modal-ViewEmail___BV_modal_body_`)[0];
                    setTimeout(() => this.iframeNewLoadedDelay(iframe,modalBody), 1000);                    
                }
            },
            iframeNewLoadedDelay(iframe,modalBody){
                    var sHeight = iframe.contentWindow.document.body.scrollHeight;
                    var buffer = 0;
                    if(sHeight<1000){
                        buffer=30;
                    }
                    else if (sHeight<10000){
                        buffer=50;
                    }
                    else {
                        buffer =sHeight/100;
                    }
                    var finalHeight = sHeight + buffer;  
                    if(finalHeight<350){
                        finalHeight=350;
                    }
                    iframe.style.height = finalHeight + 'px';
                    modalBody.scrollTop =0;
            },
            print(){
                const that = this;
                this.modals.printPDF.process = 0;
                this.modals.printPDF.open = false;
                this.modals.printPDF.process = "Printing PDF";
                this.modals.printPDF.open_process = true;

                var elementHeader = document.getElementById('emailHeaders');
                var eleHdClone= elementHeader.cloneNode(true);
                var docPrint=this.modals.iframeElPrint.contentWindow.document;
                docPrint.open();
                docPrint.write(eleHdClone.innerHTML+(this.modals.viewemail.data.body!=null?this.modals.viewemail.data.body:""));
                docPrint.close();

                var elementIframe = document.getElementById('iframePrint').contentWindow.document.body;

                var pdf_file_name = this.modals.viewemail.data.id + '_email_print.pdf';
                
                this.modals.printPDF.process = "Printing";
                const opt = {
                    margin: 0.1,
                    filename: pdf_file_name,
                    image: { type: "jpeg", quality: 1 },
                    html2canvas: {
                        scale: 2,
                        logging: true,
                        letterRendering: true,
                        useCORS: true,
                        onclone: function (doc) {
                        },
                        windowWidth: elementIframe.scrollWidth,
                        windowHeight: elementIframe.scrollHeight,
                        x:0,
                        y:0
                    },
                    jsPDF: {
                        unit: "in",
                        format: "A4",
                        orientation: "portrait",
                    },
                };
                html2pdf()
                .set(opt)
                .from(elementIframe.innerHTML)
                .toPdf()
                .save().then(
                    function (pdf) {
                        that.modals.printPDF.open_process = false;   
                    }, 
                    function(){
                        //Error Here 
                    }
                );
                    
            },
            printNative(){
                const that = this;
                this.modals.printPDF.process = 0;
                this.modals.printPDF.open = false;
                this.modals.printPDF.process = "Printing PDF";
                this.modals.printPDF.open_process = true;

                var windowTitle = document.title;
                var subjectFileName = this.modals.viewemail.data.subject.replace(/[/\\?%*:|"<>]/g, '-');
                if (subjectFileName.length > 200) subjectFileName = subjectFileName.substring(0,200);
                var elementHeader = document.getElementById('emailHeaders');
                var eleHdClone= elementHeader.cloneNode(true);
                var docPrint=this.modals.iframeElPrint.contentWindow.document;
                docPrint.open();
                docPrint.title = subjectFileName;
                docPrint.write(eleHdClone.innerHTML+(this.modals.viewemail.data.body!=null?this.modals.viewemail.data.body:""));
                docPrint.write("<style>\
                .gofixTextField .labelTitle{margin-bottom:6px}.gofixTextField .value{font-size:16px;color:#000;word-break:break-word;position:relative;width: 100%;}.gofixTextField.gofixTextFieldOneLine .inner{display:flex;line-height:1.2}.gofixTextField.gofixTextFieldOneLine .value{padding-left:15px}.gofixTextField.gofixTextFieldValueSmall .value{font-size:14px}.gofixTextField.gofixTextFieldInputStyle{background:hsla(0,0%,60%,.05);padding:22px 0 0}.gofixTextField.gofixTextFieldInputStyle .label{padding-left:16px;position:absolute;left:0;font-size:12px;top:8px;pointer-events:none;transition:all .3s;color:rgba(0,0,0,.6);text-transform:capitalize;white-space:nowrap;text-overflow:ellipsis;max-width:100%;overflow:hidden}.gofixTextField.gofixTextFieldInputStyle .value{padding:0 0 0 16px;font-size:14px;color:#000;line-height:34px}\
                .gofixTextFieldViewEmail{background-color:hsla(0,0%,60%,.05);margin-bottom:15px}.gofixTextFieldViewEmail .labelTitle .label{font-size:12px}.gofixTextFieldViewEmail .textValue{border-bottom:2px solid rgba(0,0,0,.38)}.gofixTextFieldViewEmail .textValue span{font-size:14px}\
                .gofixInput{position:relative;width:100%;margin-bottom:26px}\
                #emailHeaders div{display:block;width:100%}\
                </style>");
                docPrint.write("<style media=\"print\">\
                @page {size: auto;margin: 0mm;}\
                html {background-color: #FFFFFF;margin: 0px;}\
                body {margin: 5mm 7mm 5mm 7mm;-webkit-print-color-adjust: exact;-moz-print-color-adjust: exact;-ms-print-color-adjust: exact;print-color-adjust: exact;}\
                </style>");
                docPrint.close();

                document.title = subjectFileName;
                document.getElementById("iframePrint").contentWindow.print();
                document.title = windowTitle;
                this.modals.printPDF.open_process = false;
                return;
            },
            async downloadEML(){
            
                if(this.modals.viewemail.data.s3_eml_url){
                    let url = this.modals.viewemail.data.s3_eml_url;
                    let params = {};
                    params.url = url;
                    var subjectFileName = this.modals.viewemail.data.subject.replace(/[/\\?%*:|"<>]/g, '-');
                    if (subjectFileName.length > 200) subjectFileName = subjectFileName.substring(0,200);
                    params.image_file_name = subjectFileName + '.eml';

                    await this.$store.dispatch("FileDownloadController/getFile", params)
                    .then(response => {
                    })
                    .catch(err => {
                        this.$alertNotification("Can not download file", "danger");
                        console.log(err);
                    });
                }
                else {
                    alert('EML file not found.');
                }                    
            },
            showModalExportEmail() {
                this.modals.export.data.start_date = this.modals.export.data.end_date = null;
                this.modals.export.open = true;
            },
            updateDate() {
                var st = moment(this.modals.export.data.start_date);
                this.modals.export.min_date = new Date(st);
                this.modals.export.max_date = new Date(moment(st).add(30,'days'));
                this.modals.export.data.end_date = null;
            },
            async exportEmails() {
                if(!this.modals.export.data.start_date) {
                    return this.$alertNotification("Start date is required", "danger");
                }

                if(!this.modals.export.data.end_date) {
                    return this.$alertNotification("End date is required", "danger");
                }

                if(moment(this.modals.export.data.start_date).isAfter(this.modals.export.data.end_date)) {
                    return this.$alertNotification("Start date must be less than end date", "danger");
                }

                var st = moment(this.modals.export.data.start_date);
                var ed = moment(this.modals.export.data.end_date);
                var dayDiff = ed.diff(st, 'days');
                if(dayDiff > 31) {
                    return this.$alertNotification("Cannot export more than 31 days.", "danger");
                }

                const that = this;
                this.modals.export.process = 0;
                this.modals.export.open = false;
                this.modals.export.process = "Creating file export";
                this.modals.export.open_process = true;
                await global.axios('/api/email/export-inbox-emails', {
                    method: "GET",
                    params: {
                        start_date: moment(new Date(this.modals.export.data.start_date)).format('YYYY-MM-DD'),
                        end_date: moment(new Date(this.modals.export.data.end_date)).format('YYYY-MM-DD')
                    },
                    responseType: 'blob',
                    onDownloadProgress (progressEvent) {
                        that.modals.export.process = "Downloading";
                    }
                }).then(response => {
                    this.modals.export.loading = false;
                    this.modals.export.open_process = false;
                    this.modals.export.message.open = true;
                }).catch(err => {})
            },
        }
    }
</script>
